<template>
  <base-section id="venue">
    <v-container>
      <base-section-heading
        title="Venue — Lima, Peru"
        color="secondary"
        align="left"
        :toColor="true"
      >
        <p>
          Lima, the vibrant capital of Peru, offers an exceptional setting for international
          exchange and professional dialogue. Renowned for its stunning Pacific coastline,
          world-class culinary scene, and rich architectural heritage, the city blends tradition
          with innovation in a uniquely dynamic atmosphere. From its UNESCO-listed
          historic center to modern business districts and thriving cultural life, Lima provides
          visitors with a memorable experience defined by hospitality, creativity, and global
          connectivity.
        </p>

        <v-alert
          border="left"
          colored-border
          color="primary"
          elevation="2"
          class="mt-4"
        >
          <strong>LATS 2027</strong> will take place in <strong>Lima, Peru</strong>, from <strong>April 13 to 16, 2027</strong>.
          Further details on the specific venue and accommodation options will be announced soon.
        </v-alert>

        <v-divider class="my-6"></v-divider>

        <div class="d-flex justify-center">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d249744.38525925!2d-77.1028064!3d-12.0463731!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c5f619ee3ec9%3A0xe11e1c9b9b3b60ca!2sLima%2C%20Peru!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
            width="80%"
            height="400"
            style="border:0;"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: 'ConferenceVenue',
}
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.nowrap .v-btn__content {
  width: 100%;
  white-space: break-spaces;
  text-align: center;
}
</style>